import React from "react";
import { Link } from "react-router-dom";
import { services } from "../data";

export default function GrowCareer() {
  return (
    <section className="mu-section-dark" id="grow-career">
      <div className="container">
        <div className="section-head-row">
          <div>
            <div className="mu-eyebrow on-dark">For Artists</div>
            <h2 className="section-title">Grow Your Music Career</h2>
            <p className="section-sub">
              Everything artists need to reach a wider audience, build their brand, and
              maximize every release.
            </p>
          </div>
          <Link to="/services" className="btn-mu-outline-light">View All Services &rarr;</Link>
        </div>

        <div className="row g-3">
          {services.map((s, i) => (
            <div className="col-6 col-lg" key={i}>
              <div className="service-chip">
                <h6>{s.title}</h6>
                <p>{s.desc}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
